import { TextField } from '@mui/material';
import type { V2TextElement } from '../../../types/V2Types';
import type { V2ElementRendererProps } from './elementProps';

export function TextElement({ element, value, errors, disabled, onChange }: V2ElementRendererProps<V2TextElement>) {
	const stringValue = typeof value === 'string' ? value : '';
	const errorMessage = errors[0]?.message;
	const hasError = errors.length > 0;
	// Stable id so the input's aria-describedby can point at the helper text that
	// carries the error message — screen readers announce the error on focus (RND-4285).
	const errId = `hrr-error-${element.elementId}`;

	return (
		<TextField
			fullWidth
			value={stringValue}
			onChange={(e) => onChange(e.target.value)}
			label={element.label}
			placeholder={element.placeholder}
			helperText={errorMessage ?? element.description}
			error={hasError}
			required={element.required}
			disabled={disabled}
			multiline={element.multiline === true}
			minRows={element.multiline ? 3 : undefined}
			FormHelperTextProps={{ id: errId }}
			inputProps={{
				maxLength: element.maxLength,
				'aria-invalid': hasError,
				'aria-describedby': hasError ? errId : undefined,
				'data-cy': `hrr-element-${element.elementId}`,
				'data-element-type': 'text',
			}}
		/>
	);
}
